import { Button, Icon, Spacing, TextInput } from 'zens-storybook'
import React, { Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useNumberParams, usePaginationParam, Link } from 'zens-router'
import { useBreadcrumb } from '@dms/hook'
import { LayoutHeader, ZoneTable } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    margin: Spacing.L,
  },
  header: {
    flexDirection: 'row',
  },
  search: {
    minWidth: 300,
    marginRight: Spacing.S,
  },
})

const ScreenZoneList = () => {
  const [search, setSearch] = useState('')
  const { t } = useTranslation()
  const [{ companyId }] = useNumberParams()
  const [pagination, setPagination] = usePaginationParam()

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspaces'),
      href: `/companies/${companyId}/workspaces`,
    },
    {
      title: t('Zones'),
    },
  ])

  function updateSearch(search: string) {
    setSearch(search)
    setPagination({ page: 0, size: pagination.size })
  }

  const renderHeader = () => {
    return (
      <View style={styles.header}>
        <TextInput
          left="search"
          placeholder={t('Search zone name')}
          right={
            search ? (
              <TouchableOpacity onPress={() => updateSearch('')} testID="ZoneList.Search.Clear">
                <Icon name="close" size="S" />
              </TouchableOpacity>
            ) : undefined
          }
          value={search}
          onChangeText={updateSearch}
          style={styles.search}
          testID="ZoneList.Search"
        />
        <Link href={`/companies/${companyId}/workspaces/zones/add`} asChild>
          <Button title={t('Create zone')} left="plus" testID="ZoneList.Add" />
        </Link>
      </View>
    )
  }

  return (
    <View style={styles.container}>
      <LayoutHeader breadcrumb={breadcrumb} title={t('Zones')} accessory={renderHeader()} />
      <View style={styles.content}>
        <Suspense fallback={<ZoneTable.Skeleton />}>
          <ZoneTable companyId={companyId} search={search} pagination={pagination} onPaginationChange={setPagination} />
        </Suspense>
      </View>
    </View>
  )
}

export default ScreenZoneList
